import { render } from "./AddNewTraining.vue?vue&type=template&id=2d0d0263"
import script from "./AddNewTraining.vue?vue&type=script&lang=js"
export * from "./AddNewTraining.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__